import * as React from "react";
import { SVGProps } from "react";
const SvgQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.067 8.667c0-.9.08-1.548.241-1.942.161-.394.503-.825 1.025-1.292.456-.4.803-.747 1.042-1.041.239-.295.358-.63.358-1.009 0-.455-.152-.833-.458-1.133-.306-.3-.73-.45-1.275-.45-.567 0-.997.172-1.292.517a3.26 3.26 0 0 0-.625 1.05L.367 2.633c.233-.71.66-1.327 1.283-1.85C2.272.261 3.056 0 4 0c1.167 0 2.064.325 2.692.975.627.65.941 1.43.941 2.342 0 .555-.12 1.03-.358 1.425-.239.394-.614.841-1.125 1.341-.544.523-.875.92-.992 1.192-.116.272-.175.736-.175 1.392H3.067Zm.933 4c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.942c0-.366.13-.68.391-.941C3.32 10.13 3.633 10 4 10s.68.13.942.392c.26.26.391.575.391.941 0 .367-.13.68-.391.942a1.284 1.284 0 0 1-.942.392Z"
      fill="#005BC4"
    />
  </svg>
);
export default SvgQuestionMark;
